<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi dengan Nama Kontak"
        />
        <span class="text-danger text-sm">{{ errors.first("name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>No.Telepon</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <VuePhoneNumberInput
          default-country-code="ID"
          no-country-selector
          @update="formData.no_telp = $event.e164"
          name="telephone"
          :error="formData.no_telp === '' || formData.no_telp === null"
          v-model="formData.no_telp"
          class="w-full mb-3"
        />
        <span class="text-danger text-sm">{{ errors.first("telephone") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Email</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required|email'"
          data-vv-validate-on="blur"
          name="email"
          class="w-full sidebar-input"
          v-model="formData.email"
          placeholder="Isi dengan Email Kontak"
        />
        <span class="text-danger text-sm">{{ errors.first("email") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tentang Kontak</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="about"
          class="w-full sidebar-input"
          v-model="formData.tentang"
          placeholder="Isi dengan Tentang Kontak"
        />
        <span class="text-danger text-sm">{{ errors.first("about") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Pesan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="message"
          class="w-full sidebar-input"
          v-model="formData.pesan"
          placeholder="Isi dengan Pesan Kontak"
        />
        <span class="text-danger text-sm">{{ errors.first("message") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Status</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="statusList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="status"
          label="text"
          v-model="formData.status"
          placeholder="Pilih Status"
        />
        <span class="text-danger text-sm">{{ errors.first("status") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      statusList: [
        {
          id: 1,
          text: "Aktif",
        },
        {
          id: 2,
          text: "Tidak Aktif",
        },
      ],
      formData: {
        name: "",
        tentang: "",
        no_telp: "",
        pesan: "",
        status: null,
        email: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kontak" : "Tambah Kontak";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.tentang !== "" &&
        this.formData.pesan !== "" &&
        this.formData.no_telp !== "" &&
        this.formData.status !== null &&
        this.formData.email !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.tentang = this.passData.tentang;
        this.formData.pesan = this.passData.pesan;
        this.formData.status = this.passData.status;
        this.formData.no_telp = this.passData.no_telp;
        this.formData.email = this.passData.email;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.name = "";
      this.formData.tentang = "";
      this.formData.pesan = "";
      this.formData.status = null;
      this.formData.no_telp = "";
      this.formData.email = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.$store
        .dispatch("kontak/cudKontak", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null ? "Edit Kontak Sukses!" : "Tambah Kontak Sukses!",
            text:
              this.passData !== null
                ? `Kontak ${v.name} Berhasil diedit`
                : `Kontak ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
